import { useEffect, useState } from "react";
import axios from "axios";
import './Login.scss'
import { useNavigate } from 'react-router-dom';
import MainURL from "../../MainURL";
import { useAtomValue, useSetAtom } from "jotai";
import { kaKaoLoginDataAtom, loginPathAtom, loginStateAtom, naverLoginDataAtom, userDataAtom } from "../../AtomStore";
import { getSignupUserType, mapLoginUserData, needsUserTypeSelection, USER_TYPE_ONBOARDING_PATH } from "./userTypeUtils";

export default function LoginSns(props:any) {

  const url = new URL(window.location.href);
  const code = url.searchParams.get("code");
  const state = url.searchParams.get("state");
  
  // const [변수, set변수] = useState('');
 
  let navigate = useNavigate();
  const setIsLogin = useSetAtom(loginStateAtom);
  const setUserData = useSetAtom(userDataAtom);
  const loginPath = useAtomValue(loginPathAtom);
  const kakaoLoginData = useAtomValue(kaKaoLoginDataAtom);
  const naverLoginData = useAtomValue(naverLoginDataAtom);

  const KAKAO_API_KEY = kakaoLoginData.APIKEY;
  const KAKAO_REDIRECT_URI = kakaoLoginData.REDIRECT_URI_Auth;

  const NAVER_CLIENT_ID = naverLoginData.CLIENTID;
  const NAVER_SECRET = naverLoginData.SECRET;
  const NAVER_STATE = "sdfsdfsdf";

  const handleLoginSuccess = (data: Record<string, unknown>) => {
    localStorage.setItem("refreshToken", String(data.refreshToken || ''));
    setIsLogin(true);
    setUserData(mapLoginUserData(data));

    if (needsUserTypeSelection(data)) {
      navigate(USER_TYPE_ONBOARDING_PATH, { replace: true });
      return;
    }

    window.location.replace(loginPath || '/');
  };

  const requestToken = async () => { 
    if (code && !state) {
    axios
      .post(`${MainURL}/login/loginsnstoken`, {
        sort : 'kakao',
        client_id: KAKAO_API_KEY,
        redirect_uri: KAKAO_REDIRECT_URI,
        code: code,
        secret : '',
        state : ''
      })
      .then((res) => {
        axios
          .post(`${MainURL}/login/login`, {
            url: 'kakao',
            AccessToken: res.data,
          })
          .then((res: any) => {
            if (res.data.isUser === true) {
              handleLoginSuccess(res.data);
            } else if (res.data.isUser === false) {
              const signupUserType = getSignupUserType();
              if (signupUserType) {
                navigate('/login/logisterDetail', { state: { signupFlow: true, data: res.data, sort: 'sns' } });
              } else {
                navigate('/login/usertype', { state: { signupFlow: true, data: res.data, sort: 'sns' } });
              }
            }
          }).catch((err: string) => {
            console.log('kakao 로그인 에러:', err);
          });
      }).catch((err) => {
        console.error('kakao 토큰 에러', err);
      });
    } else if (code && state === NAVER_STATE) {
      axios
        .post(`${MainURL}/login/loginsnstoken`, {
          sort : 'naver',
          client_id: NAVER_CLIENT_ID,
          code: code,
          redirect_uri: '',
          secret : NAVER_SECRET,
          state : NAVER_STATE
        })
        .then((res) => {
          axios
            .post(`${MainURL}/login/login`, {
              url: 'naver',
              AccessToken: res.data,
            })
            .then((res: any) => {
              if (res.data.isUser === true) {
                handleLoginSuccess(res.data);
              } else if (res.data.isUser === false) {
                const signupUserType = getSignupUserType();
                if (signupUserType) {
                  navigate('/login/logisterDetail', { state: { signupFlow: true, data: res.data, sort: 'sns' } });
                } else {
                  navigate('/login/usertype', { state: { signupFlow: true, data: res.data, sort: 'sns' } });
                }
              }
            }).catch((err: string) => {
              console.log('kakao 토큰 요청 에러:', err);
            });
        }).catch((err) => {
          console.error('naver 로그인 에러', err);
        });
    }
  }

  useEffect(() =>{
    requestToken();
  }, []);

  return (
    <div></div>
  )
}
